import CustomInput from "@Components/Basic/Input/CustomInput";
import { Box, Button, Divider, Grid, styled, Typography } from "@mui/material";

export const StyledDividerWithText = styled("div")`
  display: flex;
  align-items: center;
  text-align: center;
  font-size:0.8rem;
  color: #303c49;
  &::before,
  &::after {
    content: "";
    flex: 1;
    border-bottom:1px solid
    // border-bottom: ${({ theme }) =>
      "1px solid " + theme.palette.neutral.main};
  }

  &:not(:empty)::before {
    margin-right: 0.25em;
  }

  &:not(:empty)::after {
    margin-left: 0.25em;
  }
`;

export const StyledButton = styled(Button)`
  background: ${(props) => props.theme.palette.neutral.main};
  color: ${(props) => props.theme.palette.primary.main};
  opacity: 1;
  padding: 0.5rem 1rem;
  text-align: center;
  font-family: Gotham-Light !important;
  font-size: 1.1rem;
  cursor: pointer;
  &:hover {
    background: unset;
  }
  @media (max-width: 600px) {
    width: 100%;
    font-size: 0.9rem;
    paddig: 0.2rem 1rem;
  }
`;

export const StyledSmallButton = styled(StyledButton)`
  font-size: 0.7rem;
  padding: 0.2rem 0.5rem;
  width: unset !important;
  height: 2.2rem;
  &:hover {
    background: ${(props: any) =>
      props.sx?.background! || props.theme.palette.neutral.dark};
  }
`;

export const StyledGrayButton = styled(StyledButton)`
  &:hover {
    background: ${(props) => props.theme.palette.secondary.main};
  }
`;
export const StyledGreenButton = styled(StyledButton)`
  background: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.neutral.main};
  zindex: 1;
  &:hover {
    background: ${(props) => props.theme.palette.primary.dark};
  }
  &:disabled {
    color: ${(props) => props.theme.palette.neutral.main};
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const StyledLightGreenButton = styled(StyledButton)`
  &:hover {
    // opacity: 0.4;
    background: ${(props: any) =>
      props.sx?.background! || props.theme.palette.neutral.dark};
  }
`;

export const StyledTableHeadCell = styled(Typography)`
  font-size: 14px;
  font-family: Gotham-Medium;
`;

export const StyledSmallHeading = styled(Typography)`
  font-size: 1rem !important;
`;
export const StyledName = styled(Typography)`
  font-size: 15px !important;
`;
export const StyledSmallText = styled(Typography)`
  font-size: 0.8rem !important;
`;
export const GradientBorderedBox = styled(Box)`
  padding: 1rem;
  border: 10px solid;
  border-image-slice: 1;
  border-width: 1px;
  border-image-source: linear-gradient(
    90deg,
    hsla(41, 100%, 50%, 1) 0%,
    hsla(162, 100%, 35%, 1) 48%,
    hsla(202, 100%, 46%, 1) 100%
  );
`;

export const StyledHorizontalDivider = styled(Divider)`
  width: 100%;
  height: 1px;
  margin: 0.5rem 0;
`;

export const StyledCustomInput = styled(CustomInput)`
  &&::-webkit-scrollbar {
    display: none;
  }
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
export const StyledFloatingButon = styled(StyledButton)`
  background: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.neutral.main};
  position: fixed;
  bottom: 2rem;
  right: 1rem;
  width: 15% !important;
  height: 10%;
  border-radius: 50px;
  z-index: 1000;
`;
export const StyledGridContainer = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const StyledArrow = styled(Box)`
  position: relative;
  margin-top: 10px;
  opacity: 0.8;
  &::before {
    background-color: white;
    content: "";
    display: block;
    position: absolute;
    width: 12px;
    height: 12px;
    top: -6px;
    transform: rotate(45deg);
    left: calc(50% - (-50px));
  }
`;
export const StyledShareButton = styled(Button)`
  padding: 5px;
  border-radius: 50px;
  min-width: auto;
  background-color: #ffffff;
  background: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.8);
  }
`;

export const StyledSpan = styled("span")`
  padding-left: 0.5rem;
  font-size: 15px;
`;
